<template>
  <section id="politirapport-generator" class="content white large-padding">
    <form class="hide-for-print" @submit.prevent="handleSubmit" spellcheck="false">
      <TheLoader :active="loading || exporting" :update="true"/>

      <fieldset style="margin: 0;">
        <div class="grid-x grid-padding-x">
          <TheAutoCompleteInput v-model.trim="form.code"
            ref="auksjon_input"
            containerClassName="cell large-2"
            name="Auksjon"
            :placeholder="'Velg auksjon'"
            :label="'Tilhørende auksjon'"
            :onInputCallback="onAuksjonSearchInput"
            :onSelectCallback="onAuksjonSearchSelected"
            :debounce="750"
            :minquery="2"
          >
            <div slot="item" slot-scope="props">
              <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
              <span v-if="props.item.Auksjon_dato">
                ({{ props.item.Auksjon_dato | avantidate }})
              </span>
            </div>
          </TheAutoCompleteInput>

          <div class="cell auto">
            <label>&nbsp;</label>
            <template v-if="isValidForSubmit">
              <a v-if="!(loading || exporting)" href="javascript:;" @click="handleSubmit()" class="button primary submit tiny">Ok</a>
              <a v-else-if="loading" href="javascript:;" class="button primary submit tiny loading">Ok <span class="loader-spinner"></span></a>
              <a v-else href="javascript:;" class="button primary submit tiny" disabled>Ok</a>

              <template v-if="!found || !found.objects || found.objects.length < 1">
                <a href="javascript:;" class="button primary submit tiny" disabled style="margin-left: 0.25rem;">Exporter</a>
              </template>
              <template v-else-if="exporting">
                <a href="javascript:;" class="button primary submit tiny loading" style="margin-left: 0.25rem;">Exporter <span class="loader-spinner"></span></a>
              </template>
              <template v-else>
                <a @click="handleExport()" href="javascript:;" class="button primary submit tiny" style="margin-left: 0.25rem;">Exporter</a>
              </template>
            </template>
            <template v-else>
              <a href="javascript:;" class="button primary submit tiny" disabled>Ok</a>
            </template>
          </div>
        </div>
      </fieldset>
    </form>

    <div class="content-container flex-column" v-if="found">
      <div id="scroll-container" class="content-container flex-row content-x-scroll content-y-scroll table-results">
        <!-- Pagination -->
        <div class="pagination-loader-container sidebar-padding">
          <div class="pagination-loader">
            <span class="results" v-if="found.objects.length === 1">Fant <strong>{{found.objects.length | thousands}}</strong> objekt</span>
            <span class="results" v-else>Fant <strong>{{found.objects.length | thousands}}</strong> objekter</span>

            <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
          </div>
        </div>
        <!-- // Pagination -->

        <table class="large fixed sortable compressed" style="height: 0">
          <thead>
            <tr class="header">
              <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                {{col.name}}
                <span id="sorttable_sortfwdind" v-if="sort === col.sortKey && dir === 'ASC'" class="sort-on">&nbsp;</span>
                <span id="sorttable_sortrevind" v-else-if="sort === col.sortKey && dir === 'DESC'" class="sort-on">&nbsp;</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="obj in found.objects" :key="obj.Kontraktnr + '.' + obj.Lopenr">
              <template v-for="col in columns">
                <td :key="obj.Kontraktnr + '.' + obj.Lopenr + '.' + col.key" :class="col.class">
                  {{obj[col.key]}}
                </td>
              </template>
            </tr>
            <template v-if="searchDone">
              <tr v-if="!found || !found.objects || found.objects.length < 1"><td colspan="30" style="text-align: left;">Fant ingen objekter...</td></tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInput from '../../Inputs/TheAutoCompleteInput'
import TheLoader from '../../TheLoader.vue'
import moment from 'moment'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

export default {
  name: 'VinrapportGenerator',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput,
    TheLoader
  },
  data () {
    return {
      form: {
        code: null
      },
      searchDone: false,
      exporting: false,
      loading: false,
      found: null,
      sort: 'Objektnr',
      dir: 'ASC'
    }
  },
  computed: {
    isValidForSubmit: function () {
      return this.form.code
    },
    title: function () {
      return this.$route.meta.title
    },
    columns: function () {
      // Should handle sorting
      const cols = this.$store.getters['winereport/columns']

      return cols.filter(c => c.selected)
    }
  },
  created () {
  },
  methods: {
    scrollToTop: function () {
      window.jQuery('#scroll-container').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        // Not sortable
        return
      }

      if (column.sortKey === this.sort) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      console.log(this.sort, this.dir, column.sortKey)

      this.page = 1
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable() || !this.isValidForSubmit) {
        return
      }

      this.searchDone = false
      this.loading = true

      let post = {
        code: this.form.code
      }

      const queryParams = {
        page: this.page || 1,
        sort: this.sort || 'Katalognr',
        direction: this.dir || 'ASC'
      }

      ObjektService.getWineReport(post, queryParams)
        .then(response => {
          if (response.data.objects) {
            response.data.objects.forEach(obj => {
              this.columns.forEach(c => {
                let val = ''

                if (c.key === 'sort-1') {
                  val = obj.sortering && obj.sortering[0] ? obj.sortering[0] : ''
                } else if (c.key === 'sort-2') {
                  val = obj.sortering && obj.sortering[1] ? obj.sortering[1] : ''
                } else if (c.key === 'sort-3') {
                  val = obj.sortering && obj.sortering[2] ? obj.sortering[2] : ''
                } else if (c.key === 'sort-4') {
                  val = obj.sortering && obj.sortering[3] ? obj.sortering[3] : ''
                } else {
                  val = this._.get(obj, c.key, c.default)
                }

                if (c.filter && val !== c.default) {
                  switch (c.filter) {
                    case 'date':
                      val = this.$options.filters.avantidate(val)
                      break
                    case 'datetime':
                      val = this.$options.filters.avantidatetime(val)
                      break
                    case 'integer':
                      val = this.$options.filters.thousands(val)
                      break
                    case 'decimal':
                      val = this.$options.filters.thousandsFloat(val)
                      break
                  }
                }

                obj[c.key] = val
              })
            })

            this.found = {
              objects: response.data.objects || []
            }
          } else {
            throw new Error('Kunne ikke finne objekter...')
          }
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
        })
        .then(() => {
          this.searchDone = true
          this.loading = false
        })
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.searchInSettings(query, 2)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.form.code = item.Auksjon || null
      }
    },
    exportWinereport: function () {
      return new Promise((resolve, reject) => {
        const data = []

        const headers = []

        this.columns.forEach(c => {
          headers.push(c.name)
        })
        data.push(headers)

        this.found.objects.forEach(obj => {
          const row = []

          this.columns.forEach(c => {
            row.push(obj[c.key] || '')
          })

          data.push(row)
        })

        // Finally make csv and force download...
        const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
        const blob = new Blob([csv], {
          type: 'application/csvcharset=utf-8'
        })

        fileDownload(blob, 'winereport-' + moment().format('DDMMYY.Hms') + '.csv')
        resolve()
      })
    },
    handleExport: function () {
      if (!this.found || !this.found.objects || this.found.objects.length < 1) {
        this.$helpers.showErrorAlert('Feil', 'Ingen objekter at skrive ut')
        return
      }

      this.exporting = true
      this.exportWinereport()
        .then(() => {
          this.exporting = false
        })
    }
  }
}
</script>

<style scoped>
  table.fixed tbody.empty tr td:after {
    background: none !important;
  }
  table.compressed tr th.main-text, table.compressed tr td.main-text {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/VinrapportGenerator.vue